<template>
  <article
    class="gh-card gh-card--text"
    :class="{ 'gh-card--collapsed': collapsed }"
  >
    <slot name="context-head" />
    <div class="gh-card-text__header">
      <div class="gh-card-text__header-left">
        <button type="button" class="gh-card__chevron" @click="$emit('toggle-collapse')">
          <i
            :class="collapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down' "
            aria-hidden="true"
          ></i>
        </button>
        <span class="gh-card-text__title">{{ cardTitle }}</span>
      </div>
      <GenerationHistoryCardActions
        :is-favorite="card.is_favorite"
        :is-copied="isCopied"
        @copy="$emit('copy')"
        @download="$emit('download')"
        @favorite="$emit('favorite')"
      />
    </div>
    <GenerationHistoryCardSlide :expanded="!collapsed">
      <div class="gh-card-text__body">
        <div class="gh-card-text__output">
          <div
            class="gh-card__text"
            :class="{ 'gh-dnd-source': canDrag && outputBody }"
            :draggable="canDrag && !!outputBody"
            @dragstart="onNamingTextDragStart"
            @dragend="onDragEnd"
          >
            <vue-markdown
              :source="outputBody"
              :task-lists="false"
              class="markdown-custom"
            ></vue-markdown>
          </div>
        </div>
        <div class="gh-card-text__meta">
          <GenerationHistoryMetaRows
            :fields="metaFields"
            variant="detail"
            :row-key-prefix="`naming-${card.item_id}`"
          />
        </div>
      </div>
    </GenerationHistoryCardSlide>
  </article>
</template>

<script>
import {
  getCardTitle,
  getDetailBodyMetaFields,
  removeAsterisks,
} from '@/shared/helpers/generationHistory';
import { GH_DRAG_SOURCE } from '@/shared/helpers/generationHistoryDrag';
import { generationHistoryCardDragMixin } from '@/shared/mixins/generationHistoryDragDropMixin';
import GenerationHistoryCardActions from '../shared/GenerationHistoryCardActions.vue';
import GenerationHistoryCardSlide from '../shared/GenerationHistoryCardSlide.vue';
import GenerationHistoryMetaRows from '../shared/GenerationHistoryMetaRows.vue';
import VueMarkdown from '@/shared/components/SafeMarkdown.vue';
export default {
  name: 'GenerationHistoryDetailCardNaming',
  mixins: [generationHistoryCardDragMixin],
  components: {
    GenerationHistoryCardActions,
    GenerationHistoryCardSlide,
    GenerationHistoryMetaRows,
    'vue-markdown': VueMarkdown,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    projectType: {
      type: Number,
      required: true,
    },
    cardIndex: {
      type: Number,
      default: 0,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    isCopied: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardTitle() {
      return removeAsterisks(getCardTitle(this.card));
    },
    outputBody() {
      return (this.card.output && this.card.output.text) || '';
    },
    metaFields() {
      return getDetailBodyMetaFields(this.card, this.projectType, (key) => this.$t(key), {
        cardIndex: this.cardIndex,
      });
    },
  },
  methods: {
    onNamingTextDragStart(event) {
      this.startGhTextDrag(event, {
        text: removeAsterisks(this.outputBody),
        sourceType: GH_DRAG_SOURCE.NAMING,
      });
    },
  },
};
</script>
